import { useState } from "react";
import "../../styles/administration.scss";
import Banner from "../../components/banner";
import MenuTab from "../../components/menu_tab";
import StaffHeader from "../../components/staff/staffheader";
import Footer from "../../components/footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faFileInvoiceDollar,
  faCog,
  faChartBar,
  faWater,
  faTools
} from "@fortawesome/free-solid-svg-icons";

export default function Administration() {
  const [toggleMenu, setToggleMenu] = useState(false);

  const modules = [
    {
      title: "Staff Management",
      icon: faUsers,
    },
    {
      title: "Billing",
      icon: faFileInvoiceDollar,
    },
    {
      title: "Reports",
      icon: faChartBar,
    },
    {
      title: "Water Services",
      icon: faWater,
    },
    {
      title: "Assets",
      icon: faTools,
    },
    {
      title: "Settings",
      icon: faCog,
    },
  ];

  return (
    <div className="body">
      <Banner />

      <StaffHeader
        toggleMenu={toggleMenu}
        setToggleMenu={setToggleMenu}
      />

      {toggleMenu && (
        <MenuTab
          toggleMenu={toggleMenu}
          setToggleMenu={setToggleMenu}
        />
      )}

      <div className="administration-page">
        <div className="page-title">
          <h2 className="decorated-heading">
            Administration Portal
          </h2>
        </div>

        <div className="welcome-card">
          <h3>Welcome to the Administration Portal</h3>

          <p>
            This portal provides centralized access to
            company management tools and services.
          </p>
        </div>

        {/* <div className="module-grid">
          {modules.map((module) => (
            <div
              className="module-card"
              key={module.title}
            >
              <FontAwesomeIcon
                icon={module.icon}
                className="icon"
              />

              <h4>{module.title}</h4>

              <span>Coming Soon</span>
            </div>
          ))}
        </div> */}

        <div className="footer-message">
          Thank you for your resilient efforts in making
          Githunguri Water Great.
        </div>
      </div>

      <Footer />
    </div>
  );
}